import "@hotwired/turbo-rails"
import "flowbite/dist/flowbite.turbo.js"
import "./controllers"
